import { useMutation } from '@tanstack/react-query';

import { useRequest, type MutationFunction } from '@frontend/api';

const getUseDeleteConversationKey = () => ['agents', 'conversation', 'delete'];

type DeleteConversationQueryParams = {
  uuid: string;
};

export const useDeleteConversation: MutationFunction<
  unknown,
  void,
  [DeleteConversationQueryParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    () =>
      request(`/agents/conversations/${params.uuid}`, {
        init: {
          method: 'DELETE',
        },
      }),
    {
      ...queryOptions,
      mutationKey: getUseDeleteConversationKey(),
    },
  );
};
